import axios from 'axios';
import { API_BASE_URL } from '../constants/api';

const TOKEN_KEY = 'homematters_auth_token';

export const authService = {
  // Login user
  login: async (email, password) => {
    const response = await axios.post(`${API_BASE_URL}/auth/login`, {
      email,
      password
    });
    
    if (response.data.token) {
      localStorage.setItem(TOKEN_KEY, response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.profile));
    }
    
    return response.data;
  },

  // Logout user
  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('user');
  },

  // Get current token
  getToken: () => {
    return localStorage.getItem(TOKEN_KEY);
  },

  // Get current user
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem(TOKEN_KEY);
  },

  // Verify token is still valid
  verifyToken: async () => {
    const token = authService.getToken();
    if (!token) return false;

    try {
      const response = await axios.get(`${API_BASE_URL}/auth/whoami`, {
        headers: {
          'x-access-token': token
        }
      });
      return response.status === 200;
    } catch (error) {
      authService.logout();
      return false;
    }
  }
};

// Add axios interceptor to include token in all requests
axios.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers['x-access-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add axios interceptor to handle 401 responses
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
